import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';

import {TYPE_CLICK} from '../../../constants/tagManager';
import {EC_REPRESENTATIVE_DATA} from '../../../constants/typesMessages';
import {analyticsService} from '../../../services/analytics';
import {
  pushInteractionTagManagerChatbot,
  pushNoInteractionTagManagerChatbot
} from '../../../services/tagManager';
import {HideButtonWhenLogout} from '../../../shared/components/HideButtonWhenLogout';
import {useChatStore} from '../../../store/slices/chatStore';
import {useLogoutStore} from '../../../store/slices/logoutStore';

const MessageQuestion = (props) => {
  const responseFlowChange = useChatStore((state) => state.responseFlowChange);
  const responseTypeChange = useChatStore((state) => state.responseTypeChange);
  const setMessages = useChatStore((state) => state.setMessages);
  const setGoLogout = useLogoutStore((state) => state.setGoLogout);
  const [hiddenButtons, setHiddenButtons] = useState('');

  const continueChat = () => {
    setHiddenButtons('hidden');
    analyticsService.trackAccreditationStart();

    pushInteractionTagManagerChatbot({
      ...TYPE_CLICK,
      elementContent: 'step-1:sim:inicio-continuar'
    });

    let messages = [
      {
        text: 'Sim',
        edit: 'buttons-options-start-chat',
        type: 'response-sent'
      },
      {
        text: 'Legal, bora começar!',
        type: 'message-receive'
      },
      {
        text: '',
        type: 'message-start-icon'
      },
      {
        text: 'Qual o seu nome completo?',
        type: 'message-receive'
      }
    ];
    setMessages(messages);
    responseTypeChange(EC_REPRESENTATIVE_DATA.FLOW);
    responseFlowChange(EC_REPRESENTATIVE_DATA.NAME);

    pushNoInteractionTagManagerChatbot({
      elementContent: 'step-2:none:nome'
    });
  };

  const pauseChat = () => {
    setHiddenButtons('hidden');

    pushInteractionTagManagerChatbot({
      ...TYPE_CLICK,
      elementContent: 'step-1:mais-tarde:inicio-mais-tarde'
    });

    let messages = [
      {
        text: 'Mais Tarde',
        edit: 'buttons-options-start-chat',
        type: 'response-sent'
      },
      {
        text: 'Tudo bem, quando tiver tudo em mãos, basta voltar aqui no chat que a gente segue de onde parou. Tá bem?',
        type: 'message-accreditation-close'
      }
    ];
    setGoLogout(true);
    setMessages(messages);
    responseTypeChange('disabled');
  };

  useEffect(() => {
    responseTypeChange('disabled');
  }, []);

  return (
    <div>
      <div className="message-line">
        <div
          className="message-receive"
          id={`msg-${props.question.id}`}
          data-aut-test="message-receive-text"
        >
          <div
            className="message-div"
            data-aut-test="message-options-continue-question"
          >
            {props.question.text}
          </div>
        </div>
      </div>
      <HideButtonWhenLogout>
        <div
          className={`message-line ${hiddenButtons}`}
          id={`buttons-options-continue-${props.question.id}`}
          data-aut-test="buttons-options-continue-chat-now-or-later"
        >
          <div className="div-button">
            <button
              id="continuar-chat-mais-tarde"
              data-testid="continue-chat-later"
              data-aut-test="continue-chat-later"
              type="button"
              onClick={() => pauseChat()}
            >
              MAIS TARDE
            </button>
            <button
              id="continuar-chat-agora"
              data-testid="continue-chat-now"
              data-aut-test="continue-chat-now"
              type="button"
              onClick={() => continueChat()}
            >
              SIM
            </button>
          </div>
        </div>
      </HideButtonWhenLogout>
    </div>
  );
};

MessageQuestion.propTypes = {
  question: PropTypes.object
};

export default MessageQuestion;
